wbApp.controller('StudentsDetailCtrl', ['$scope', 'studentSvc', 'securitySvc', 'tenantSettingSvc', '$http',
function ($scope, studentSvc, securitySvc, tenantSettingSvc, $http) {

    $scope.tenantSetting = tenantSettingSvc.settings;
    
    $scope.modelOrig = angular.copy($scope.model);
    $scope.isInSupportRole = securitySvc.isInRole('Support');
    $scope.isInProtectedViewRole = securitySvc.isInRole('Student.ProtectedView');

    $scope.onDetailSave = function (data) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        if (data.isNew) {
            studentSvc.insert(data, success, error, $scope.collection);
        } else {
            studentSvc.update(data, success, error, $scope.collection);
        }

        function success(newStudent) {
            if (!!$scope.onStudentSave) {
                $scope.onStudentSave(newStudent);
            }
            $scope.$hide();
        }

        function error(errorResult) {
            $scope.detailError = errorResult;
            $scope.isSaving = false;
        }
    }

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.modelOrig) && !$scope.preFilled;
    };

    $scope.detailTabs = [
        {
            title: 'TXT_MAIN',
            template: "users/students/students-detail-main-tab.html"
        },
        {
            title: 'TXT_LBL_ADITIONAL',
            template: "users/students/students-detail-aditional-tab.html"
        },
        {
            title: 'TXT_LAB_HEALTH',
            template: "users/students/students-detail-health-tab.html"
        }
    ];
    
    if ($scope.tenantSetting.mandatoryStudentNotes < 3) {
        $scope.detailTabs.push(
            {
                title: 'TXT_LBL_NOTE',
                template: "users/students/students-detail-notes-tab.html"
            });
    }

    $scope.detailTabs.activeTab = 0;

    $scope.typeAheadAddress = [];

    $scope.allMatch = function () {
        return true;
    };

    $scope.getAddress = function (viewValue) {
        if (viewValue) {
            let params = {
                address: viewValue,
                language: 'cs',
                region: 'cz',
                bounds: '48.270777,12.172380|51.246709,19.922157', // Czech republic bounds
                key: 'AIzaSyDdpRFWJaEcASaUgQxTdi8i42aaCaKfS0A'
            };
            return $http.get('https://maps.googleapis.com/maps/api/geocode/json', { params: params })
                .then(function (res) {
                    $scope.typeAheadAddress.length = 0;
                    $scope.typeAheadAddress.push.apply($scope.typeAheadAddress, res.data.results);
                });
        }
    };    

}]);
